export enum attributeTypes {
  BOOLEAN = 'bit',
  INTEGER = 'int',
  FLOAT = 'float',
  STRING = 'string',
  DATE = 'date'
}
